/** @jsx jsx */
import { AnimatePresence, motion, TargetAndTransition } from "framer-motion";
import { forwardRef } from "react";
import { Menu, MenuProps } from "reakit/Menu";
import { jsx } from "theme-ui";

export const animationVariants: Record<"enter" | "exit", TargetAndTransition> = {
  enter: {
    opacity: 1,
    y: 8,
    transition: {
      type: "spring",
      stiffness: 260,
      damping: 30,
    },
    display: "block",
    pointerEvents: "all",
  },
  exit: {
    opacity: 0,
    y: -16,
    pointerEvents: "none",
    transition: {
      ease: "easeInOut",
    },
    transitionEnd: {
      display: "none",
    },
  },
};

interface DropdownMenuProps extends MenuProps {}

export const DropdownMenu = forwardRef<HTMLDivElement, DropdownMenuProps>(({ children, ...menuProps }, ref) => (
  <Menu
    {...menuProps}
    sx={{
      outline: "none",
      zIndex: "modal",
    }}
    ref={ref}
    aria-label="dropdown-menu">
    <AnimatePresence>
      {menuProps.visible && (
        <motion.div
          key="menu"
          initial="exit"
          animate="enter"
          exit="exit"
          variants={animationVariants}
          sx={{
            boxShadow: "sm",
            border: "primary",
            borderRadius: "md",
            bg: "n0",
            outline: "none",
            minWidth: 200,
          }}
          onAnimationComplete={menuProps.stopAnimation}>
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  </Menu>
));
